import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  DEBUG_LOG_ENABLED,
  SESSION_ID,
  BASE_URL,
  ACCESS_TOKEN,
} from "../Constant";
import axios from "axios";
import swal from "sweetalert";
import useDebounce from "../report/useDebounce/useDebounce"; // Make sure to import your debounce hook
import UserSearchDropdown from "../report/CustomDropdown/UserSearchDropdown";
import { GET_DATA_BYNAME_MOBILE } from "../report/visitConstant/ApiConstant";
import { ADD_DOCTOR_ON_BOARD } from "../report/visitConstant/ApiConstant";
import apiHelper from "../report/ApiHelpar/apiHelper";
import BranchSearchDropdown from "../report/BranchSearchDropDown/BranchSearchDropDown";

export default function DrSignUp({ dataEdit }) {
  const navigate = useNavigate();
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // State for dropdown functionality
  const [nameOptions, setNameOptions] = useState([]);
  const [mobileOptions, setMobileOptions] = useState([]);
  const [nameInput, setNameInput] = useState("");
  const [mobileInput, setMobileInput] = useState("");

  // Expanded initial state to include more fields
  const [customer, setCustomer] = useState({
    name: nameInput || "",
    mobileNo: mobileInput || "",
    emailId: "",
    username: "",
    password: "",
    type: "General",
    specialization: "",
    registrationNo: "",
    registrationDate: "",
    dateOfBirth: "",
    gender: "Male",
    branchId: 0,
    salutation: "",
    role: "ROLE_USER",
    address: "",
    age: "",
    preferredLanguage: "English",
    city: "",
    pin: "",
    ageUnit: "Years",
    // fcmToken: "",
    days: "1,2,3,4,5,6,7",
    // faceId: "",
  });

  // New state for optional customer details
  const [customerDetails, setCustomerDetails] = useState({
    newEntry: true,
    maritalStatus: "",
    since: "",
    spouseBloodGroup: "",
    bloodGroup: "",
    spouseName: "",
    existingId: "",
    channel: "",
    mobile2: "",
    email: "",
    co: "",
    aadharNumber: "",
    tag: "",
    occupation: "",
  });

  // Debounce search inputs
  const debouncedNameInput = useDebounce(nameInput, 500);
  const debouncedMobileInput = useDebounce(mobileInput, 700);

  // Search handlers
  useEffect(() => {
    if (debouncedNameInput?.trim()) {
      fetchData({ name: debouncedNameInput }, setNameOptions);
      handleChange({
        target: {
          name: "name",
          value: debouncedNameInput,
        },
      });
    }
  }, [debouncedNameInput]);

  useEffect(() => {
    if (debouncedMobileInput?.trim()) {
      fetchData({ mobileNo: debouncedMobileInput }, setMobileOptions);
      handleChange({
        target: {
          name: "mobileNo",
          value: debouncedMobileInput,
        },
      });
    }
  }, [debouncedMobileInput]);

  const fetchData = async (params, setOptions) => {
    setLoading(true);

    try {
      const response = await apiHelper(GET_DATA_BYNAME_MOBILE, params);

      if (response?.respData?.respMsg) {
        setOptions(response.respData.respMsg);
      }
    } catch (error) {
      console.error("Search error:", error);
      setOptions([]);
    } finally {
      setLoading(false);
    }
  };

const handleSelect = (selectedItems) => {

  if (!selectedItems?.customerId)return

  const selectedItem = selectedItems?.customerId;
  console.log("handleSelect===", selectedItem);

  // Normalize gender mapping
  const normalizeGender = (gender) => {
    if (gender === "M") return "Male";
    if (gender === "F") return "Female";
    return gender || "Male";
  };

  // Map selected item to customer state
  const mappedCustomer = {
    customerId: selectedItem?.customerId || null,
    name: selectedItem.name || "",
    salutation: selectedItem.salutation || "",
    emailId: selectedItem.emailId || "",
    mobileNo: selectedItem.mobileNo || "",
    username: selectedItem.username || "",
    password: "", // Always reset password
    fcmToken: selectedItem.fcmToken || "",
    role: selectedItem.role || "ROLE_USER",
    address: selectedItem.address || "",
    age: selectedItem.age || "",
    gender: normalizeGender(selectedItem.gender),
    dateOfBirth: selectedItem.dob || "", // Mapping dob to dateOfBirth
    preferredLanguage: selectedItem.preferredLanguage || "English",
    city: selectedItem.city || "",
    pin: selectedItem.pin || "",
    newEntry: false,
    ageUnit: selectedItem.ageUnit || "Years",
    visitCount: selectedItem.visitCount || 0,
    faceId: selectedItem.faceId || "",
    type: "General", // Default type, adjust as needed
    branchId: 0, // Reset branch ID
  };

  // Map customer details
  const mappedCustomerDetails = selectedItem.customerDetails
    ? {
        id: selectedItem.customerDetails.id || null,
        newEntry: false,
        maritalStatus: selectedItem.customerDetails.maritalStatus || "",
        since: selectedItem.customerDetails.since || "",
        spouseBloodGroup: selectedItem.customerDetails.spouseBloodGroup || "",
        bloodGroup: selectedItem.customerDetails.bloodGroup || "",
        spouseName: selectedItem.customerDetails.spouseName || "",
        existingId: selectedItem.customerDetails.existingId || "",
        channel: selectedItem.customerDetails.channel || "",
        mobile2: selectedItem.customerDetails.mobile2 || "",
        email: selectedItem.customerDetails.email || selectedItem.emailId,
        co: selectedItem.customerDetails.co || "",
        aadharNumber: selectedItem.customerDetails.aadharNumber || "",
        tag: selectedItem.customerDetails.tag || "",
        occupation: selectedItem.customerDetails.occupation || "",
        mobileNo:
          selectedItem.customerDetails.mobileNo || selectedItem.mobileNo,
      }
    : {};

  // Update states
  setCustomer((prevCustomer) => ({
    ...prevCustomer,
    ...mappedCustomer,
  }));

  // Update customer details
  setCustomerDetails((prevDetails) => ({
    ...prevDetails,
    ...mappedCustomerDetails,
  }));

  // Update input fields
  setNameInput(selectedItem.name || "");
  setMobileInput(selectedItem.mobileNo || "");

  // Optional: Reset branch-specific fields if needed
  if (customer.branchId > 0) {
    // Reset username and password fields
    setCustomer((prevCustomer) => ({
      ...prevCustomer,
      username: "",
      password: "",
    }));
  }
};

  const handleAddNewItem = (field, value) => {
    setCustomer({ ...customer, [field]: value });
    if (field === "name") setMobileInput("");
    if (field === "mobileNo") setNameInput("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCustomer({ ...customer, [name]: value });
  };

  // Handle customer details changes
  const handleCustomerDetailsChange = (e) => {
    const { name, value } = e.target;
    setCustomerDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };

  const saveCustomer = async (e) => {
    e.preventDefault();

    if (!customer.name || !customer.mobileNo) {
      swal("Please fill all required fields");
      return;
    }

    if (customer.branchId > 0) {
      if (!customer.username || !customer.password) {
        swal("Please fill username and password for branch selection");
        return false;
      }
      if (confirmPassword !== customer.password) {
        swal("Passwords do not match");
        return;
      }
    }

    setLoading(true);
    try {
      const customerData = {
        pubInfo: { sessionId: localStorage.getItem(SESSION_ID) },
        request: {
          busiParams: {
            ...customer,
            type: customer.type === "Specialization" ? 1 : 0,
            newEntry: true,
            customerDetails: customerDetails.mobile2 ? customerDetails : null,
          },
          isEncrypt: false,
          transactionId: "897987987989",
        },
      };
      console.log(customerData);
      const response = await axios.post(
        BASE_URL + ADD_DOCTOR_ON_BOARD,
        customerData,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
            "Access-Control-Allow-Headers": "Content-Type",
            Authorization:
              "Bearer eyJhbGciOiJIUzUxMiJ9.eyJVU0VSIjoiZG9jdG9yIiwic3ViIjoiZHJqYW5hcmRhbm11a2t1QGdtYWlsLmNvIiwiaWF0IjoxNzQzMTU0NTM0LCJleHAiOjE3NDUxODI1MzR9.Izr56bOv-brG-4CAnYdufvUcmVmN9Tf1NhGTRVwNUYWbLci_NPNnRZFiI8DkYkZW79mJpXd0F1uwZkWcOePrCQ",

            //+ localStorage.getItem(ACCESS_TOKEN),
          },
        }
      );

      console.log("response--------", response);

      // if (response.data.respData.status === "SUCCESS") {
      swal(response.data.respData.message);

      // }
    } catch (error) {
      swal("Registration failed: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const BranchSelec = (branchId) => {
    handleChange({
      target: {
        name: "branchId",
        value: branchId.id,
      },
    });
  };

  // Populate form for editing
useEffect(() => {
  if (dataEdit) {
    const data = { customerId: dataEdit };
    handleSelect(data);
  }
}, [dataEdit]);

  return (
    <div
      className="justify-content-center w-100 h-100"
      style={{ maxWidth: 700 }}
    >
      <div className="card mx-auto">
        <div className="card-header">
          <h4 className="mb-0">Doctor Registration</h4>
        </div>
        <div className="card-body">
          <form>
            {/* Name Field */}
            <div className="form-group mb-3">
              <label className="form-label">Full Name*</label>
              <UserSearchDropdown
                options={nameOptions}
                handleInputChange={setNameInput}
                onSelect={handleSelect}
                value={nameInput}
                loading={loading}
                Placeholder="Enter Name"
                onAddNewItem={(value) => handleAddNewItem("name", value)}
                searchTerm={nameInput}
                newEntry={true}
              />
            </div>

            {/* Mobile Number Field */}
            <div className="form-group mb-3">
              <label className="form-label">Mobile Number*</label>
              <UserSearchDropdown
                options={mobileOptions}
                handleInputChange={setMobileInput}
                onSelect={handleSelect}
                value={mobileInput}
                loading={loading}
                Placeholder="Enter Number"
                onAddNewItem={(value) => handleAddNewItem("mobileNo", value)}
                searchTerm={mobileInput}
                newEntry={true}
                inputType="tel"
              />
            </div>

            {/* Rest of the form fields */}
            <div className="form-group mb-3">
              <label className="form-label">Email address*</label>
              <input
                type="text"
                name="emailId"
                value={customer.emailId}
                onChange={handleChange}
                className="form-control"
                placeholder="Email Address"
                required
              />
            </div>

            {/* Gender Selection */}
            <div className="form-group mb-3">
              <label className="form-label">Gender*</label>
              <div className="btn-group w-100" role="group">
                {["Male", "Female", "Other"].map((gender) => (
                  <React.Fragment key={gender}>
                    <input
                      type="radio"
                      className="btn-check"
                      name="gender"
                      id={`gender${gender}`}
                      value={gender}
                      checked={customer.gender === gender}
                      onChange={handleChange}
                    />
                    <label
                      className="btn btn-outline-primary"
                      htmlFor={`gender${gender}`}
                    >
                      {gender}
                    </label>
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* Doctor Type Selection */}
            <div className="form-group mb-3">
              <label className="form-label">Type*</label>
              <div className="btn-group w-100" role="group">
                {["General", "Specialization"].map((type) => (
                  <React.Fragment key={type}>
                    <input
                      type="radio"
                      className="btn-check"
                      name="type"
                      id={`type${type}`}
                      value={type}
                      checked={customer.type === type}
                      onChange={handleChange}
                    />
                    <label
                      className="btn btn-outline-primary"
                      htmlFor={`type${type}`}
                    >
                      {type}
                    </label>
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* Specialization Field */}
            {customer.type === "Specialization" && (
              <div className="form-group mb-3">
                <label className="form-label">Specialization*</label>
                <input
                  type="text"
                  name="specialization"
                  value={customer.specialization}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Your specialization"
                  required
                />
              </div>
            )}

            {/* Registration Details */}
            <div className="form-group mb-3">
              <label className="form-label">Registration Number</label>
              <input
                type="text"
                name="registrationNo"
                value={customer.registrationNo}
                onChange={handleChange}
                className="form-control"
                placeholder="Registration Number"
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label">Registration Date</label>
              <input
                type="date"
                name="registrationDate"
                value={customer.registrationDate}
                onChange={handleChange}
                className="form-control"
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label">Date of Birth</label>
              <input
                type="date"
                name="dateOfBirth"
                value={customer.dateOfBirth}
                onChange={handleChange}
                className="form-control"
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label">Branch*</label>

              <BranchSearchDropdown
                hospitalId={0}
                onSelect={(e) => BranchSelec(e)}
                selectedBranchId={customer.branchId}
              />
            </div>

            {customer.branchId > 0 && (
              <>
                {/* Username Field */}
                <div className="form-group mb-3">
                  <label className="form-label">Username*</label>
                  <input
                    type="text"
                    name="username"
                    value={customer.username}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter Username"
                    required
                  />
                </div>

                {/* Password Fields */}
                <div className="form-group mb-3">
                  <label className="form-label">Password*</label>
                  <input
                    type="password"
                    name="password"
                    value={customer.password}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Password"
                    required
                  />
                </div>

                <div className="form-group mb-4">
                  <label className="form-label">Confirm Password*</label>
                  <input
                    type="password"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="form-control"
                    placeholder="Confirm Password"
                    required
                  />
                </div>

                {/* Optional Customer Details Section */}
                <div className="card mb-3">
                  <div className="card-header">
                    <h5 className="mb-0">Optional Customer Details</h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Marital Status</label>
                        <select
                          name="maritalStatus"
                          value={customerDetails?.maritalStatus}
                          onChange={handleCustomerDetailsChange}
                          className="form-control"
                        >
                          <option value="">Select Status</option>
                          <option value="Single">Single</option>
                          <option value="Married">Married</option>
                          <option value="Divorced">Divorced</option>
                          <option value="Widowed">Widowed</option>
                        </select>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label">Blood Group</label>
                        <select
                          name="bloodGroup"
                          value={customerDetails.bloodGroup}
                          onChange={handleCustomerDetailsChange}
                          className="form-control"
                        >
                          <option value="">Select Blood Group</option>
                          <option value="A+">A+</option>
                          <option value="A-">A-</option>
                          <option value="B+">B+</option>
                          <option value="B-">B-</option>
                          <option value="O+">O+</option>
                          <option value="O-">O-</option>
                          <option value="AB+">AB+</option>
                          <option value="AB-">AB-</option>
                        </select>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label">Occupation</label>
                        <input
                          type="text"
                          name="occupation"
                          value={customerDetails.occupation}
                          onChange={handleCustomerDetailsChange}
                          className="form-control"
                          placeholder="Enter Occupation"
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label">Aadhar Number</label>
                        <input
                          type="text"
                          name="aadharNumber"
                          value={customerDetails.aadharNumber}
                          onChange={handleCustomerDetailsChange}
                          className="form-control"
                          placeholder="Enter Aadhar Number"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
              <button
                type="submit"
                className="btn btn-primary text-light"
                disabled={loading}
                onClick={saveCustomer}
              >
                {loading ? "Processing..." : "Register Doctor"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
